// apps/web/src/features/admin/form-config/recognition/ConfusedPairsTable.tsx

interface ConfusedPair {
  wrongFormId: string;
  correctFormId: string;
  count: number;
}

interface ConfusedPairsTableProps {
  pairs: ConfusedPair[];
}

export function ConfusedPairsTable({ pairs }: ConfusedPairsTableProps) {
  if (pairs.length === 0) return null;

  const sorted = [...pairs].sort((a, b) => b.count - a.count);

  return (
    <div className="confused-pairs">
      <h4>CONFUSED PAIRS</h4>
      <table>
        <thead>
          <tr>
            <th>Wrong Form</th>
            <th>Correct Form</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((pair, i) => (
            <tr key={i}>
              <td>{pair.wrongFormId}</td>
              <td>{pair.correctFormId}</td>
              <td>{pair.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
